/**
 *
 * key
 *
 */

 const key = 'Y2xlYXJhbmNlTGV2ZWwx'

 export default key
 